<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="mt-16 d-flex align-center justify-center">
          <v-img
            style="cursor:pointer"
            @click="onClickLogo"
            max-height="150"
            max-width="250"
            src="@/assets/img/logo.svg"
          ></v-img>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" lg="12" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                <v-tabs grow v-model="loginTabs" class="my-16" light>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab :href="`#tab-login`">
                    Сброс пароля
                  </v-tab>
                  <v-tab-item :value="'tab-login'" >
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">

                          <v-col>
                            <p class="login-slogan display-2 text-center font-weight-medium mt-10">Ввод нового пароля</p>
                            <p class="login-slogan display-1 text-center font-weight-medium mb-10"></p>
                          </v-col>

                          <v-form ref="formRegistration" lazy-validation v-model="registerFormValid" :disabled="!isVerifyToken">
                            <v-col>
                              <v-text-field
                                light
                                v-model="email"
                                disabled
                                outlined
                                label="Email"
                                placeholder="Email"
                                persistent-placeholder
                                required
                              ></v-text-field>
                              <v-text-field
                                autocomplete="new-password"
                                light
                                v-model="password"
                                :append-icon="showPassRegister ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassRegister ? 'text' : 'password'"
                                @click:append="showPassRegister = !showPassRegister"
                                @input="onValidateConfirmPass"
                                :rules="passRules"
                                outlined
                                label="Пароль"
                                hint=""
                                placeholder="Пароль"
                                persistent-placeholder
                                required
                              ></v-text-field>
                              <v-text-field
                                ref="confirm"
                                autocomplete="new-password"
                                light
                                v-model="password_confirm"
                                :rules="[v => v === this.password || 'Пароли не совпадают']"
                                outlined
                                :type="showPassRegister ? 'text' : 'password'"
                                label="Подтвердить пароль"
                                hint=""
                                placeholder="Подтвердить пароль"
                                persistent-placeholder
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                light
                                large
                                block
                                :disabled="! isValidFormRegistration || ! isVerifyToken"
                                color="primary"
                                :loading="regIsFetching"
                                @click="onSend">Отправить</v-btn>
                            </v-col>
                          </v-form>
                          <v-overlay :value="isFetchVerifyToken">
                            <v-progress-circular
                              indeterminate
                              size="64"
                            ></v-progress-circular>
                          </v-overlay>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-tab-item>
                </v-tabs>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-footer>
                <div class="primary--text">© {{new Date().getFullYear()}} ООО "ЖКХ Онлайн" все права защищены</div>
              </v-footer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <notification @close-notification="onClickSnackbarError"></notification>
  </v-app>
</template>

<script>
import axios from '@/plugins/axios';
import { mapActions } from 'vuex'
import Notification from '@/app/components/Notification';
export default {
  components: { Notification},
  name: 'ResetPassword',
  data() {
    return {
      isVerifyToken: false,
      isFetchVerifyToken: false,
      showPassRegister:false,
      valid: true,
      loginTabs: '',
      email: '',
      password: '',
      password_confirm: '',
      registerFormValid: false,
      regIsFetching: false,
      emailRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => /.+@.+/.test(v) || 'Укажите дейсвительный email',
        // v => v.toLowerCase() === this.email
      ],
      passRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => /(?=.*[0-9])(?=.*[а-яa-z])(?=.*[А-ЯA-Z])/.test(v) || 'Требования к паролю: Буквы на кириллице или латинице, минимум одна прописная и одна заглавная, минимум одно число. Пароль должен содержать не менее 8 символов.',
        v => v.length >= 8 || 'Минимальная длина 8 символов',
      ],
      pushAfterError: false
    }
  },
  methods: {
      ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
      onClickLogo(){
        window.location.href = '/';
      },
      onClickSnackbarError(){
        if(this.pushAfterError){
          this.$router.push({name: 'Login'});
        }
      },
      onValidateConfirmPass(){
        this.$refs.confirm.validate()
      },
      showSuccessMessage(message){
        this.SHOW_SUCCESS(message);
      },
      showErrorMessage(message){
        this.SHOW_ERROR({message, timeout: 10000});
      },
      async onSend(){
          if(!this.$refs.formRegistration.validate()){
            return;
          }
          this.regIsFetching = true;
          await this.send();
          this.regIsFetching = false;
      },
      async verifyToken(){
          try{
            this.isFetchVerifyToken = true;
            let result = await axios.post(`/reset/verify/${this.$route.params.token}`, {email: this.email});
            this.isVerifyToken = result.data.result;
            if(!this.isVerifyToken){
              this.showErrorMessage("Срок действия ссылки истек, отправьте запрос на восстановление пароля заново");
              setTimeout(() => this.$router.push({name: 'Login'}), 11000);
              this.pushAfterError = true;
            }
          }catch(err){
            console.log(err);
            this.isVerifyToken = true;
          }finally{
            this.isFetchVerifyToken = false;
          }
      },
      async send(){
          try{
            let result = await axios.post('/reset', {
                email: this.email, 
                password: this.password, 
                password_confirmation: this.password_confirm,
                token: this.$route.params.token
            });
            this.showSuccessMessage(result.data.message);
            setTimeout(() => {
                this.$router.push({name: 'Login'});
            }, 3000);
          }catch(err){
            console.log(err);
            let errorMessage = 'Ошибка изменения пароля';
            if(err.response.data && err.response.data.error){
                errorMessage = err.response.data.error;
            }
            this.showErrorMessage(errorMessage);
          }
      }
  },
  computed: {
    isValidFormRegistration(){
        return this.registerFormValid === true;
    },
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.email = urlParams.get("email");
    this.verifyToken();
  },
}
</script>